// Fungsi untuk memetakan deskripsi menjadi jenis transaksi dalam konteks Kompack
function mapDescriptionToText(desc) {
  const descriptionMapping = {
    outbound_fee: 'Outbound',
    outbound_goods: 'Penarikan Barang',
    payment_low_moving_stock: 'Biaya Low Moving Stok',
    outbound_cancel: 'Pembatalan Outbound',
    payment_marketplace_fulfillment_fee: 'Outbound Marketplace',
    cancel_marketplace_fulfillment_fee: 'Pembatalan Outbound Marketplace',
  }
  return descriptionMapping[desc] || 'Penarikan Saldo'
}

export default mapDescriptionToText
